import { render, staticRenderFns } from "./UpdateUserStateModal.vue?vue&type=template&id=07a6f70a&scoped=true&"
import script from "./UpdateUserStateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserStateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6f70a",
  null
  
)

export default component.exports